<template>
  <main ref="document">
    <contact-us-blurb />
    <div
      v-if="$route.query.share"
      class="container-fluid bg-white pt-4"
    >
      <div class="container">
        <share-portal-notification
          name="a patient"
          :isvalid="isvalid"
        />
      </div>
    </div>
    <div class="container-fluid bg-white pt-4">
      <div class="container">
        <food-navbar
          :source="$route.query.share ? 'share_portal' : 'tracker'"
          current="progress-reports"
        />
      </div>
    </div>
    <div
      v-if="isvalid"
      class="container-fluid bg-white py-5"
    >
      <div class="container">
        <div
          v-show="current_view == ''"
          class="progress-report-options"
        >
          <div class="split">
            <div class="side">
              <a @click="current_view = 'factor-averages'">
                <div class="box">
                  <div class="chart-container">
                    <factor-averages-report-chart
                      :chart_datasets="factor_averages_report_data_fake.chart_datasets"
                      :chart_labels="factor_averages_report_data_fake.chart_labels"
                      :chart_options="hide_labels"
                    />
                  </div>
                  <div class="title">View Factor Averages Report</div>
                </div>
              </a>
            </div>
            <div class="side">
              <a @click="current_view = 'color-averages'">
                <div class="box">
                  <div class="chart-container">
                    <color-averages-report-chart
                      :chart_datasets="color_averages_report_data_fake.chart_datasets"
                      :chart_labels="color_averages_report_data_fake.chart_labels"
                      :chart_options="hide_labels"
                    />
                  </div>
                  <div class="title">View Color Averages Report</div>
                </div>
              </a>
            </div>
            <div class="side">
              <a @click="current_view = 'daily-meal-factors'">
                <div class="box">
                  <div class="chart-container">
                    <daily-meal-factors-report-chart
                      :chart_datasets="daily_meal_factors_report_data_fake.chart_datasets"
                      :chart_labels="daily_meal_factors_report_data_fake.chart_labels"
                      :chart_options="hide_labels"
                    />
                  </div>
                  <div class="title">View Daily Meal Factors Report</div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <vue-html2pdf
          ref="factoraverages"
          :html-to-pdf-options="{
            margin: 8,
            filename: 'Factor-Averages-Report--'+factor_averages_report_data.from+'--'+factor_averages_report_data.to+'.pdf',
            jsPDF: {
              format: 'a4',
              orientation: 'landscape',
            }
          }"
          :show-layout="true"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :manual-pagination="false"
          :paginate-elements-by-height="800"
          :pdf-quality="2"
          pdf-content-width="90%"
        >
          <section slot="pdf-content">
            <div
              v-show="current_view == 'factor-averages'"
              class="report-window"
            >
              <a
                class="back-nav-simple"
                @click="current_view = ''"
              ><i class="fas fa-arrow-left" /> Back to Reports</a>
              <h1>Factor Averages Report</h1>

              <div class="meta-bar">
                <div class="split">
                  <div class="left">
                    Showing {{ date_friendly(factor_averages_report_data.from) }} - {{ date_friendly(factor_averages_report_data.to) }}
                  </div>
                  <div class="right">
                    <span
                      class="button tertiary"
                      @click="generate_pdf"
                    ><i
                      class="fas fa-download"
                      aria-hidden="true"
                    />Download PDF</span>
                    <a
                      class="button"
                      @click="factor_averages_report_data.is_showing_filters = !factor_averages_report_data.is_showing_filters"
                    ><i
                      class="fas fa-calendar-day"
                      aria-hidden="true"
                    />Change Time Period</a>
                  </div>
                </div>
              </div>

              <div
                v-show="factor_averages_report_data.is_showing_filters"
                class="chart-filters"
              >
                <h4>Change Time Period</h4>
                <div class="time-period-row">
                  <div class="split">
                    <div class="side label">
                      <label><input
                        v-model="factor_averages_report_data.type"
                        type="radio"
                        name="factor_averages_report_data.type"
                        value="day"
                      > <strong>Show Daily:</strong></label><br>
                      <label><input
                        v-model="factor_averages_report_data.type"
                        type="radio"
                        name="factor_averages_report_data.type"
                        value="week"
                      > <strong>Show Week to Week:</strong></label><br>
                      <label><input
                        v-model="factor_averages_report_data.type"
                        type="radio"
                        name="factor_averages_report_data.type"
                        value="month"
                      > <strong>Show Month to Month:</strong></label>
                    </div>
                    <div class="side input">
                      <label>From: <date-picker
                        v-model="factor_averages_report_data.from"
                        :hidenav="hidenav"
                        @input="update_input"
                      /></label>
                      <label>To: <date-picker
                        v-model="factor_averages_report_data.to"
                        :hidenav="hidenav"
                        @input="update_input"
                      /></label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-container">
                <factor-averages-report-chart
                  :chart_datasets="factor_averages_report_data.chart_datasets"
                  :chart_labels="factor_averages_report_data.chart_labels"
                />
              </div>
            </div>
          </section>
        </vue-html2pdf>

        <vue-html2pdf
          ref="coloraverages"
          :html-to-pdf-options="{
            margin: 8,
            filename: 'Color-Averages-Report--'+color_averages_report_data.from+'--'+color_averages_report_data.to+'.pdf',
            jsPDF: {
              format: 'a4',
              orientation: 'landscape',
            }
          }"
          :show-layout="true"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :manual-pagination="false"
          :paginate-elements-by-height="800"
          :pdf-quality="2"
          pdf-content-width="90%"
        >
          <section slot="pdf-content">
            <div
              v-show="current_view == 'color-averages'"
              class="report-window"
            >
              <a
                class="back-nav-simple"
                @click="current_view = ''"
              ><i class="fas fa-arrow-left" /> Back to Reports</a>
              <h1>Color Averages Report</h1>

              <div class="meta-bar">
                <div class="split">
                  <div class="left">
                    Showing {{ date_friendly(color_averages_report_data.from) }} - {{ date_friendly(color_averages_report_data.to) }}
                  </div>
                  <div class="right">
                    <span
                      class="button tertiary"
                      @click="generate_pdf"
                    ><i
                      class="fas fa-download"
                      aria-hidden="true"
                    />Download PDF</span>
                    <a
                      class="button"
                      @click="color_averages_report_data.is_showing_filters = !color_averages_report_data.is_showing_filters"
                    ><i
                      class="fas fa-calendar-day"
                      aria-hidden="true"
                    />Change Time Period</a>
                  </div>
                </div>
              </div>

              <div
                v-show="color_averages_report_data.is_showing_filters"
                class="chart-filters"
              >
                <h4>Change Time Period</h4>
                <div class="time-period-row">
                  <div class="split">
                    <div class="side label">
                      <label><input
                        v-model="color_averages_report_data.type"
                        type="radio"
                        name="color_averages_report_data.type"
                        value="day"
                      > <strong>Show Daily:</strong></label><br>
                      <label><input
                        v-model="color_averages_report_data.type"
                        type="radio"
                        name="color_averages_report_data.type"
                        value="week"
                      > <strong>Show Week to Week:</strong></label><br>
                      <label><input
                        v-model="color_averages_report_data.type"
                        type="radio"
                        name="color_averages_report_data.type"
                        value="month"
                      > <strong>Show Month to Month:</strong></label>
                    </div>
                    <div class="side input">
                      <label>From: <date-picker
                        v-model="factor_averages_report_data.from"
                        :hidenav="hidenav"
                        @input="update_input"
                      /></label>
                      <label>To: <date-picker
                        v-model="factor_averages_report_data.to"
                        :hidenav="hidenav"
                        @input="update_input"
                      /></label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-container">
                <color-averages-report-chart
                  :chart_datasets="color_averages_report_data.chart_datasets"
                  :chart_labels="color_averages_report_data.chart_labels"
                />
              </div>
            </div>
          </section>
        </vue-html2pdf>
        <vue-html2pdf
          ref="dailymealfactors"
          :html-to-pdf-options="{
            margin: 8,
            filename: 'Daily-Meal-Factors-Report--'+daily_meal_factors_report_data.from+'.pdf',
            jsPDF: {
              format: 'a4',
              orientation: 'landscape',
            }
          }"
          :show-layout="true"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :manual-pagination="false"
          :paginate-elements-by-height="800"
          :pdf-quality="2"
          pdf-content-width="90%"
        >
          <section slot="pdf-content">
            <div
              v-show="current_view == 'daily-meal-factors'"
              class="report-window"
            >
              <a
                class="back-nav-simple"
                @click="current_view = ''"
              ><i class="fas fa-arrow-left" /> Back to Reports</a>
              <h1>Daily Meal Factors Report</h1>

              <div class="meta-bar">
                <div class="split">
                  <div class="left">
                    Showing data for {{ date_friendly(daily_meal_factors_report_data.from) }}
                  </div>
                  <div class="right">
                    <span
                      class="button tertiary"
                      @click="generate_pdf"
                    ><i
                      class="fas fa-download"
                      aria-hidden="true"
                    />Download PDF</span>
                    <a
                      class="button"
                      @click="daily_meal_factors_report_data.is_showing_filters = !daily_meal_factors_report_data.is_showing_filters"
                    ><i
                      class="fas fa-calendar-day"
                      aria-hidden="true"
                    />Change Time Period</a>
                  </div>
                </div>
              </div>

              <div
                v-show="daily_meal_factors_report_data.is_showing_filters"
                class="chart-filters"
              >
                <h4>Change Time Period</h4>
                <div class="time-period-row">
                  <div class="split">
                    <div class="side label">
                      <label><input
                        v-model="daily_meal_factors_report_data.type"
                        type="radio"
                        name="daily_meal_factors_report_data.type"
                        value="day"
                      > <strong>Show Day:</strong></label>
                    </div>
                    <div class="side input">
                      <label>Day: <date-picker
                        v-model="factor_averages_report_data.from"
                        :hidenav="hidenav"
                        @input="update_input"
                      /></label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-container">
                <daily-meal-factors-report-chart
                  :chart_datasets="daily_meal_factors_report_data.chart_datasets"
                  :chart_labels="daily_meal_factors_report_data.chart_labels"
                  :individual_factor="daily_meal_factors_report_data.individual_factor"
                  :daily_factor="daily_meal_factors_report_data.daily_factor"
                />
              </div>
            </div>
          </section>
        </vue-html2pdf>

        <!--Loading Modal -->
        <div
          v-if="showModal"
          id="loading-modal"
        >
          <div id="spinner-container">
            <div
              class="spinner-border"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Upgrade Modal -->
    <upgrade-modal
      v-show="is_showing_upgrade_modal"
      @show-modal="is_showing_upgrade_modal = true"
      @hide-modal="is_showing_upgrade_modal = false"
    />
  </main>
</template>

<script>
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'
//import html2pdf from 'html2pdf.js'
import FactorAveragesReportChart from '../components/FactorAveragesReportChart.js'
import ColorAveragesReportChart from '../components/ColorAveragesReportChart.js'
import DailyMealFactorsReportChart from '../components/DailyMealFactorsReportChart.js'
import DatePicker from "../components/DatePicker";

export default {
  name: 'ProgressReports',
  components: {
    DatePicker,
    FactorAveragesReportChart,
    ColorAveragesReportChart,
    DailyMealFactorsReportChart,
    VueHtml2pdf
  },
  data() {
    return {
      isvalid:true,
      patient:'',
      current_view: '',
      hidenav:'hide',
      months:['January','February','March','April','May','June','July','August','September','October','November','December'],
      selectedinput:'',
      is_showing_upgrade_modal: false,
      factor_averages_report_data: {
        chart_labels: Array.from({length: 30}, (e, i) => "January " + (i + 1)),
        chart_datasets: [
          {
            data: Array.from({length: 30}, () => Math.floor(Math.random() * 30) + 10),
            backgroundColor: '#9b59b6',
            maxBarThickness: 84,
          },
        ],
        type: 'day',
        from: moment().startOf('month').format('YYYY-MM-DD'),
        to: moment().endOf('month').format('YYYY-MM-DD'),
        is_showing_filters: false,
      },
      factor_averages_report_data_fake: {
        chart_labels: Array.from({length: 30}, (e, i) => "January " + (i + 1)),
        chart_datasets: [
          {
            data: Array.from({length: 30}, () => Math.floor(Math.random() * 30) + 10),
            backgroundColor: '#9b59b6',
            maxBarThickness: 84,
          },
        ],
      },
      color_averages_report_data: {
        chart_labels: ['Breakfast', 'Lunch', 'Dinner', 'Snack'],
        chart_datasets: [
          {
            label: 'Green Foods',
            data: [20, 30, 40, 50],
            backgroundColor: '#669933',
            maxBarThickness: 84,
          },
          {
            label: 'Yellow Foods',
            data: [20, 30, 40, 10],
            backgroundColor: '#ffcc00',
            maxBarThickness: 84,
          },
          {
            label: 'Red Foods',
            data: [60, 40, 20, 40],
            backgroundColor: '#cc3333',
            maxBarThickness: 84,
          },
        ],
        type: 'day',
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        is_showing_filters: false,
      },
      color_averages_report_data_fake: {
        chart_labels: ['Breakfast', 'Lunch', 'Dinner', 'Snack'],
        chart_datasets: [
          {
            label: 'Green Foods',
            data: [20, 30, 40, 50],
            backgroundColor: '#669933',
            maxBarThickness: 84,
          },
          {
            label: 'Yellow Foods',
            data: [20, 30, 40, 10],
            backgroundColor: '#ffcc00',
            maxBarThickness: 84,
          },
          {
            label: 'Red Foods',
            data: [60, 40, 20, 40],
            backgroundColor: '#cc3333',
            maxBarThickness: 84,
          },
        ],
      },
      daily_meal_factors_report_data: {
        chart_labels: ['Meals'],
        chart_datasets: [
          {
            label: 'Breakfast',
            data: [6],
            backgroundColor: '#2a9df4',
            maxBarThickness: 84,
          },
          {
            label: 'Lunch',
            data: [4],
            backgroundColor: '#187bcd',
            maxBarThickness: 84,
          },
          {
            label: 'Dinner',
            data: [9],
            backgroundColor: '#1167b1',
            maxBarThickness: 84,
          },
          {
            label: 'Snack',
            data: [2],
            backgroundColor: '#03254c',
            maxBarThickness: 84,
          },
        ],
        type: 'day',
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        is_showing_filters: false,
        individual_factor: 0,
        daily_factor: 0,
      },
      daily_meal_factors_report_data_fake: {
        chart_labels: ['Meals'],
        chart_datasets: [
          {
            label: 'Breakfast',
            data: [6],
            backgroundColor: '#2a9df4',
            maxBarThickness: 84,
          },
          {
            label: 'Lunch',
            data: [4],
            backgroundColor: '#187bcd',
            maxBarThickness: 84,
          },
          {
            label: 'Dinner',
            data: [9],
            backgroundColor: '#1167b1',
            maxBarThickness: 84,
          },
          {
            label: 'Snack',
            data: [2],
            backgroundColor: '#03254c',
            maxBarThickness: 84,
          },
        ],
      },
      hide_labels: {
        scales: {
          yAxes: [{
            display: false,
          }],
          xAxes: [{
            display: false,
          }],
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
      showModal:false
    };
  },
  watch: {
    'current_view': function(){
      if (this.$parent.user.type != 'individual') {
        this.is_showing_upgrade_modal = true;
        this.current_view = '';
      } else {
        this.load_section();
      }
    },
    'factor_averages_report_data.type': function(){this.load_section()},
    'factor_averages_report_data.from': function(){this.load_section()},
    'factor_averages_report_data.to': function(){this.load_section()},
    'color_averages_report_data.type': function(){this.load_section()},
    'color_averages_report_data.from': function(){this.load_section()},
    'color_averages_report_data.to': function(){this.load_section()},
    'daily_meal_factors_report_data.type': function(){this.load_section()},
    'daily_meal_factors_report_data.from': function(){this.load_section()}
    /*daily_meal_factors_report_data: {
			handler(v){
				console.log(v);
				if (v.type == 'today') {
					this.daily_meal_factors_report_data.from = moment().format('YYYY-MM-DD');
					this.daily_meal_factors_report_data.to = moment().format('YYYY-MM-DD');
				}
			},
			deep: true
		},*/
  },
  async mounted() {
    //this.load_section();
  },
  methods: {
    moment() {
      return moment();
    },
    date_friendly(d) {
      return moment(d).format('MMMM Do YYYY');
    },
    load_section(){
      console.log("curr:"+this.current_view);
      if(this.current_view == 'factor-averages'){
        this.load_factor_averages();
      }
      if(this.current_view == 'color-averages'){
        this.load_color_averages();
      }
      if(this.current_view == 'daily-meal-factors'){
        this.load_daily_meal_factors();
      }

    },
    async load_factor_averages(){

      // Build query string from object
      var params = {
        period: this.factor_averages_report_data.type,
        date_from: this.factor_averages_report_data.from,
        date_to: this.factor_averages_report_data.to,
      };
      var esc = encodeURIComponent;
      var query = '?' + Object.keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&');

      // Fetch data
      this.showModal=true;
      let fetch_factor_averages = await this.$http('/api/share-portal/factorhistory' + query, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(async function(json) {
          return json;
        });
      console.log('factor averages');
      console.log(fetch_factor_averages);
      if(fetch_factor_averages.length>0){
        let ffa = fetch_factor_averages;
        this.factor_averages_report_data.chart_labels=[];
        this.factor_averages_report_data.chart_datasets[0].data=[];

        for(let i=0; i<ffa.length; i++){
          let dt = ffa[i].date_from_simple.split("-");
          let label ='';
          if(this.factor_averages_report_data.type=='month'){
            label = this.months[parseInt(dt[1]-1)];
          }else{
            label = this.months[parseInt(dt[1]-1)]+' '+dt[2];
          }
          this.factor_averages_report_data.chart_labels.push(label);
          this.factor_averages_report_data.chart_datasets[0].data.push(ffa[i].data.summary.average);
        }
      }
      this.showModal=false;
    },
    async load_color_averages(){

      // Build query string from object
      var params = {
        period: this.color_averages_report_data.type,
        date_from: this.color_averages_report_data.from,
        date_to: this.color_averages_report_data.to,
      };
      var esc = encodeURIComponent;
      var query = '?' + Object.keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&');

      // Fetch data
      this.showModal=true;
      let fetch_color_averages = await this.$http('/api/share-portal/colorhistory' + query, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(async function(json) {
          return json;
        });
      console.log('color averages');
      console.log(fetch_color_averages);
      if(fetch_color_averages.length>0){
        let fca = fetch_color_averages;
        this.color_averages_report_data.chart_labels=[];
        this.color_averages_report_data.chart_datasets[0].data=[];
        this.color_averages_report_data.chart_datasets[1].data=[];
        this.color_averages_report_data.chart_datasets[2].data=[];

        for(let i=0; i<fca.length; i++){
          let dt = fca[i].date_from_simple.split("-");
          let label ='';
          if(this.color_averages_report_data.type=='month'){
            label = this.months[parseInt(dt[1]-1)];
          }else{
            label = this.months[parseInt(dt[1]-1)]+' '+dt[2];
          }
          this.color_averages_report_data.chart_labels.push('Breakfast / '+label);
          this.color_averages_report_data.chart_labels.push('Lunch / '+label);
          this.color_averages_report_data.chart_labels.push('Dinner / '+label);
          this.color_averages_report_data.chart_labels.push('Snack / '+label);

          this.color_averages_report_data.chart_datasets[0].data.push(fca[i].data.breakfast.green_percentage);
          this.color_averages_report_data.chart_datasets[0].data.push(fca[i].data.lunch.green_percentage);
          this.color_averages_report_data.chart_datasets[0].data.push(fca[i].data.dinner.green_percentage);
          this.color_averages_report_data.chart_datasets[0].data.push(fca[i].data.snack.green_percentage);

          this.color_averages_report_data.chart_datasets[1].data.push(fca[i].data.breakfast.yellow_percentage);
          this.color_averages_report_data.chart_datasets[1].data.push(fca[i].data.lunch.yellow_percentage);
          this.color_averages_report_data.chart_datasets[1].data.push(fca[i].data.dinner.yellow_percentage);
          this.color_averages_report_data.chart_datasets[1].data.push(fca[i].data.snack.yellow_percentage);

          this.color_averages_report_data.chart_datasets[2].data.push(fca[i].data.breakfast.red_percentage);
          this.color_averages_report_data.chart_datasets[2].data.push(fca[i].data.lunch.red_percentage);
          this.color_averages_report_data.chart_datasets[2].data.push(fca[i].data.dinner.red_percentage);
          this.color_averages_report_data.chart_datasets[2].data.push(fca[i].data.snack.red_percentage);

        }
      }
      this.showModal=false;
    },
    async load_daily_meal_factors(){

      // Build query string from object
      var params = {
        period: this.daily_meal_factors_report_data.type,
        date_from: this.daily_meal_factors_report_data.from,
        date_to: this.daily_meal_factors_report_data.from
      };
      var esc = encodeURIComponent;
      var query = '?' + Object.keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&');

      // Fetch data
      this.showModal=true;
      let daily_meal_factors = await this.$http('/api/share-portal/mealhistory' + query, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(async function(json) {
          return json;
        });
      console.log('daily meal factors');
      console.log(daily_meal_factors);

      if(daily_meal_factors.length>0){
        let dmf = daily_meal_factors;
        this.daily_meal_factors_report_data.chart_datasets[0].data = [dmf[0].data.breakfast.total];
        this.daily_meal_factors_report_data.chart_datasets[1].data = [dmf[0].data.lunch.total];
        this.daily_meal_factors_report_data.chart_datasets[2].data = [dmf[0].data.dinner.total];
        this.daily_meal_factors_report_data.chart_datasets[3].data = [dmf[0].data.snack.total];
        this.daily_meal_factors_report_data.individual_factor = dmf[0].data.individual_factor;
        this.daily_meal_factors_report_data.daily_factor = dmf[0].data.totals.total;
        console.log('updated');
        console.log(this.daily_meal_factors_report_data);
      }
      this.showModal=false;
    },
    update_input(info){
      console.log('info');
      console.log(info);
      this.load_section();
    },
    generate_pdf(){
      // Scroll to top and close filters
      window.scrollTo(0, 0);
      this.factor_averages_report_data.is_showing_filters = false;
      this.color_averages_report_data.is_showing_filters = false;
      this.daily_meal_factors_report_data.is_showing_filters = false;

      // Generate
      if(this.current_view == 'factor-averages'){
        this.$refs.factoraverages.generatePdf();
      }
      if(this.current_view == 'color-averages'){
        this.$refs.coloraverages.generatePdf();
      }
      if(this.current_view == 'daily-meal-factors'){
        this.$refs.dailymealfactors.generatePdf();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
    @import '../../sass/vars';
    #loading-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        // background-color: #fafafa;
        background-color: #000000;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 1060;
        animation: modal-fade 300ms ease forwards;
    }

    #spinner-container {
        text-align: center;
        padding-top: 50vh;
    }

    .spinner-border {
        color: $green;
    }

    @keyframes modal-fade {
        to {
            opacity: .75;
        }
    }

</style>
